module.exports = __webpack_public_path__ + "44bc206d5d57b24a36b48b79a490639c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-12.png
// module id = 3171
// module chunks = 0